import { render, staticRenderFns } from "./swiper-card.vue?vue&type=template&id=35109688&scoped=true&"
import script from "./swiper-card.vue?vue&type=script&lang=js&"
export * from "./swiper-card.vue?vue&type=script&lang=js&"
import style0 from "./swiper-card.vue?vue&type=style&index=0&id=35109688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35109688",
  null
  
)

export default component.exports